<template>
    <div class="pricing-plan" :class="item.recommended ? 'recommended' : ''">
        <div v-if="item.recommended" class="recommended-badge">Recommended</div>
        <h3>{{ item.type.name }}</h3>
        <p class="margin-top-10">{{ item.description }}
        </p>
        <div class="pricing-plan-label billed-monthly-label skeleton">
            <template v-if="item.price">
                <strong>${{ item.price }}</strong>
            </template>
        </div>
        <!-- <div class="pricing-plan-label billed-yearly-label"><strong>$529</strong>/ yearly</div> -->
        <div class="pricing-plan-features ">
            <strong>Features</strong>
            <ul>
                <li :class="[feature == 'blank' ? 'text-white' : '']" class="skeleton" v-for="(feature, i) in item.features"
                    :key="i">
                    {{ feature }}</li>
            </ul>
        </div>
        <button @click="select" class="button full-width margin-top-20">Get Started</button>
    </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
    props: {
        item: {}
    },
    methods: {
        ...mapMutations('checkout', ['setSelectedPackage']),
        select() {
            const { category, type, price } = this.item;
            this.setSelectedPackage({
                category, type, price
            });
            if (this.item.description.toLowerCase().indexOf("resume") > -1)
                this.$emit("proceed", this.item);
            else {
                this.$router.push({ path: this.item.to, query: { userType: 2, packageSelected: type.value } })
            }
        }
    },
}
</script>
<style lang="scss" scoped>
.loading div h3 {
    background-color: #f2f2f2;
    animation: pulse 1s infinite;
}

.loading .button {
    pointer-events: none;
    opacity: 0.3;
}

.loading .skeleton:before {
    content: "";
    display: inline-block;
    width: 100%;
    height: 16px;
    background-color: #f2f2f2;
    animation: pulse 1s infinite;
}

@keyframes pulse {
    0% {
        background-color: #f2f2f2;
    }

    50% {
        background-color: #e6e6e6;
    }

    100% {
        background-color: #f2f2f2;
    }
}
</style>